export enum IaaSProvider {
    AWS = 'aws',
    Azure = 'azure',
    Bare = 'bare-metal',
    Edge = 'edge',
    GCP = 'gcp',
    NONE = 'NOT_PROVISIONED',
}
